import { useExternalScheduleForm } from '@hooks/forms/useExternalScheduleForm';
import { useToast } from '@hooks/useToast';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalScheduleDialog } from '..';
import { ExternalScheduleGenericDialogProps } from './types';
import { ExternalScheduleContactsInputs } from '../../inputs/contacts';
import { ExternalScheduleDateInputs } from '../../inputs/date';

export default function ExternalScheduleGenericDialog({
  type,
  open,
  setOpen,
  completed,
  taskId = '',
  schedule,
  importantTasks,
  jobId = '',
  note,
  name,
  extraComment,
}: ExternalScheduleGenericDialogProps) {
  const { t } = useTranslation('app');
  const { toast } = useToast();

  const { form, onSubmit, locked } = useExternalScheduleForm({
    jobId,
    taskId,
    scheduleId: schedule?.id,
    note,
    successHandler: () => {
      form.reset();
      setOpen(false);
      toast({
        title: t(`messages.success.inspection.${schedule?.id ? 'reschedule' : 'schedule'}`),
      });
    },
  });

  const { setValue } = form;

  useEffect(() => {
    if (type !== 'ohInspection') return;
    setValue('confirmed', true);
  }, [open, setValue, type]);

  return (
    <ExternalScheduleDialog
      type={type}
      open={open}
      setOpen={setOpen}
      completed={completed}
      form={form}
      onSubmit={onSubmit}
      locked={locked}
      jobId={jobId}
      taskId={taskId}
      schedule={schedule}
      note={note}
      name={name}
      extraComment={extraComment}
      importantTasks={importantTasks}>
      <ExternalScheduleDateInputs form={form} disabled={completed} />
      <ExternalScheduleContactsInputs form={form} jobId={jobId} />
    </ExternalScheduleDialog>
  );
}
